/* eslint-disable max-lines */

import { StateHelper } from 'utils/StateHelper';

import * as CurrentUserTypes from 'reactApp/modules/CurrentUserModule/CurrentUserModule.types';

export type CurrentUserModuleState = Partial<CurrentUserTypes.UserApiEntity> & {
    selectedPid: string;
    infraToken: string;
    projectsOSData: CurrentUserTypes.UsersProjectsOS;
    isFirstLoginAfterEmailConfirmation: boolean;
    isShowPhoneVerificationDialog: boolean;
};

export const INITIAL_STATE: CurrentUserModuleState = {
    email: '',

    tfa: false,

    verified: { email: false, phone: false },

    name: '',
    phone: 0,
    projects: [],
    projectsOSData: {},

    attr: {
        position: '',
        company: '',
        type: CurrentUserTypes.UserTypeEnum.mcs,
    },

    selectedPid: '',
    infraToken: '',
    isFirstLoginAfterEmailConfirmation: false,
    isShowPhoneVerificationDialog: false,
};

export const CurrentUserModule = StateHelper.createModuleState<
    CurrentUserModuleState
>('CurrentUser', INITIAL_STATE);
